import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  ISendingMemberGetMemberModel,
  IMemberGetMemberAdvancedListRequest,
  IMemberGetMemberModel
} from './models/member-get-member-model';
import { IPagination } from '../../shared/interfaces/pagination';

@Injectable({
  providedIn: 'root'
})
export class MemberGetMemberService {
  private apiUrl = `${environment.baseApimUrl}/members`;

  constructor(private http: HttpClient) {}

  sendInvites(payload: ISendingMemberGetMemberModel): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/send-mail`, payload);
  }

  copyLink(vetId: number): string {
    const token = btoa(`vet:${vetId}`);
    return `${environment.urlPvet}cadastro?inviteToken=${token}`;
  }

  listInvites(
    payload: IMemberGetMemberAdvancedListRequest
  ): Observable<IPagination<IMemberGetMemberModel>> {
    return this.http.post<IPagination<IMemberGetMemberModel>>(
      `${this.apiUrl}/advanced/list`,
      { ...payload }
    );
  }
}
